import React from 'react';
import { createRoot } from 'react-dom/client';
import { UploadPage } from './pages/UploadPage';
import { PreviewPage } from './pages/PreviewPage';
import './styles/app.css';

function mount(id: string, element: React.ReactNode) {
  const node = document.getElementById(id);
  if (!node) return;
  createRoot(node).render(<React.StrictMode>{element}</React.StrictMode>);
}

const params = new URLSearchParams(window.location.search);
const previewId = params.get('preview') || params.get('id');
const legacyPrefix = ['paw', 'bond'].join('');

mount('portrait-upload-app', previewId ? <PreviewPage /> : <UploadPage />);
mount('portrait-preview-app', <PreviewPage />);
mount(`${legacyPrefix}-upload-app`, previewId ? <PreviewPage /> : <UploadPage />);
mount(`${legacyPrefix}-preview-app`, <PreviewPage />);
